// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dpf7","controls":"styles_controls__3po1a","charLimit":"styles_charLimit__2vn3Z","input":"styles_input__3yc0D","send":"styles_send__3-py2"};